module.exports = __webpack_public_path__ + "static/media/eclipse-total.51bd9603.jpeg";